import { useMutation, UseMutationOptions } from 'react-query';

import Api from '../../api/api';

export type RequestAccountDeletionDto = {
  fullname: string;
  email: string;
  phone: string;
  reason: string;
};

export const requestAccountDeletion = async (params: RequestAccountDeletionDto): Promise<void> => {
  const [response, bodyOrError] = await Api.post('users/account-deletion-request', params);

  if (!response?.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useRequestAccountDeletion = (
  options?: Omit<UseMutationOptions<void, Error, RequestAccountDeletionDto, unknown>, 'mutationFn' | 'mutationKey'>,
) =>
  useMutation({
    ...options,
    mutationKey: ['requestAccountDeletion'],
    mutationFn: requestAccountDeletion,
  });
